import { create } from 'zustand';

type DrawerTab = 'workflow' | 'subagents';

interface TraceDrawerState {
  isOpen: boolean;
  activeTab: DrawerTab;
  open: () => void;
  openTab: (tab: DrawerTab) => void;
  close: () => void;
  toggle: () => void;
  setActiveTab: (tab: DrawerTab) => void;
}

/**
 * Zustand store for trace drawer visibility state.
 * Separate from URL state to avoid polluting navigation history
 * for transient UI state.
 *
 * The trace ID is intentionally NOT stored here — it is derived from
 * the currently-selected conversation and passed to TraceDrawer as a
 * prop, so switching conversations can never leave stale data in view.
 */
export const useTraceDrawerStore = create<TraceDrawerState>((set, get) => ({
  isOpen: false,
  activeTab: 'workflow',
  open: () => set({ isOpen: true, activeTab: 'workflow' }),
  openTab: (tab: DrawerTab) => set({ isOpen: true, activeTab: tab }),
  close: () => set({ isOpen: false }),
  toggle: () => {
    const { isOpen } = get();
    if (isOpen) {
      set({ isOpen: false });
    }
  },
  setActiveTab: (tab: DrawerTab) => set({ activeTab: tab }),
}));
